var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16107_20926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4003 22.1917L27.562 20.7542C27.5853 20.5325 27.6053 20.2734 27.6053 19.9992C27.6053 19.725 27.5862 19.4659 27.562 19.2442L29.402 17.8059C29.7437 17.5359 29.837 17.0567 29.6195 16.6575L27.7078 13.35C27.5037 12.9767 27.0562 12.785 26.602 12.9525L24.4328 13.8233C24.017 13.5233 23.5812 13.27 23.1303 13.0675L22.8003 10.7667C22.7462 10.33 22.3662 10 21.917 10H18.0837C17.6345 10 17.2554 10.33 17.202 10.76L16.8712 13.0692C16.4345 13.2659 16.0054 13.5159 15.5712 13.825L13.3962 12.9517C12.9887 12.7942 12.5012 12.9708 12.2987 13.3425L10.3845 16.6542C10.1587 17.0359 10.252 17.5317 10.6012 17.8084L12.4395 19.2459C12.4103 19.5267 12.3962 19.7709 12.3962 20C12.3962 20.2292 12.4104 20.4734 12.4395 20.755L10.5995 22.1934C10.2578 22.4642 10.1653 22.9434 10.3828 23.3417L12.2945 26.6492C12.4987 27.0217 12.942 27.215 13.4003 27.0467L15.5695 26.1759C15.9845 26.475 16.4203 26.7284 16.8712 26.9317L17.2012 29.2317C17.2553 29.67 17.6345 30 18.0845 30H21.9178C22.367 30 22.747 29.67 22.8003 29.24L23.1312 26.9317C23.5678 26.7342 23.9962 26.485 24.4312 26.175L26.6062 27.0483C26.7112 27.0891 26.8203 27.11 26.9328 27.11C27.2562 27.11 27.5537 26.9333 27.7037 26.6583L29.6237 23.3333C29.837 22.9433 29.7437 22.4642 29.4003 22.1917ZM20.0003 23.3333C18.162 23.3333 16.667 21.8383 16.667 20C16.667 18.1617 18.162 16.6667 20.0003 16.6667C21.8387 16.6667 23.3337 18.1617 23.3337 20C23.3337 21.8383 21.8387 23.3333 20.0003 23.3333Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16107_20926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b9e122e81caa51e1e7caec44daa6ed46.svg";
export { ForwardRef as ReactComponent };